import { render, staticRenderFns } from "./RegisterWizardStepFive.vue?vue&type=template&id=0de7803e&scoped=true"
import script from "./RegisterWizardStepFive.vue?vue&type=script&lang=js"
export * from "./RegisterWizardStepFive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de7803e",
  null
  
)

export default component.exports